import React, { useState } from 'react';
import Fachada from '../assets/FachadaIpsum.png';
import './ContactForm.css';
import { FaMapMarkerAlt } from 'react-icons/fa';

const ContactForm = () => {



  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  // Estado adicional para el archivo
  const [reciboLuz, setReciboLuz] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // --- NUEVA FUNCIÓN para manejar el cambio del input de archivo ---
  const handleFileChange = (e) => {
    setReciboLuz(e.target.files[0]); // Guarda el primer archivo seleccionado
  };
  // --- FIN NUEVA FUNCIÓN ---
  const [phoneError, setPhoneError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.email.includes('@')) {
      alert('Ingresa un correo electrónico válido.');
      return;
    }

    if (formData.phone.trim() !== '' && !/^\d+$/.test(formData.phone.trim())) {
      alert('El teléfono debe contener solo números.');
      return;
    }

    try {
      // --- CAMBIO CLAVE: Usar FormData para enviar archivos ---
      const dataToSend = new FormData();
      dataToSend.append('name', formData.name);
      dataToSend.append('email', formData.email);
      dataToSend.append('phone', formData.phone);
      dataToSend.append('message', formData.message);

      if (reciboLuz) {
        dataToSend.append('recibo_luz', reciboLuz); // Añade el archivo si existe
      }
      // --- FIN CAMBIO CLAVE ---

      const response = await fetch(
        'https://www.ipsumiei.com.co/api/send_email.php',
        {
          method: 'POST',
          // --- IMPORTANTE: NO establezcas 'Content-Type' aquí cuando uses FormData con archivos. ---
          // El navegador lo establecerá automáticamente como 'multipart/form-data' con el boundary correcto.
          body: dataToSend, // Envía el objeto FormData
        }
      );

      if (response.ok) {
        alert('¡Tu mensaje ha sido enviado con éxito!');
        setFormData({ name: '', email: '', phone: '', message: '' }); // Limpia los campos de texto
        setReciboLuz(null); // Limpia el campo de archivo
      } else {
        const errorData = await response.json();
        console.error('Error al enviar el email:', errorData);
        alert(
          `Hubo un error al enviar tu mensaje: ${errorData.error || 'Por favor, inténtalo de nuevo más tarde.'}`
        );
      }
    } catch (error) {
      console.error('Error de red al enviar el formulario:', error);
      alert('Hubo un error de conexión. Por favor, inténtalo de nuevo.');
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <form onSubmit={handleSubmit} className="contact-form">
          <h3>Resolvemos tus dudas</h3>

          <div className="form-group">
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label htmlFor="name">Nombre</label>
          </div>

          <div className="form-group">
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label htmlFor="email">Correo electrónico</label>
          </div>

          <div className="form-group">
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={(e) => {
                const inputValue = e.target.value;
                const onlyNums = inputValue.replace(/\D/g, '');

                if (inputValue !== onlyNums) {
                  setPhoneError('Solo se permiten números.');
                } else {
                  setPhoneError('');
                }

                setFormData({ ...formData, phone: onlyNums });
              }}
              inputMode="numeric"
              pattern="[0-9]*"
              placeholder=" "
            />
            <label htmlFor="phone">Teléfono</label>
            {phoneError && (
              <small className="error-message">{phoneError}</small>
            )}
          </div>

          <div className="form-group file-upload">
            <input
              type="file"
              id="recibo_luz"
              name="recibo_luz"
              accept="image/*"
              onChange={handleFileChange}
            />
            <label htmlFor="recibo_luz">
              Foto del Recibo de la Luz (Opcional)
            </label>
          </div>

          <div className="form-group">
            <textarea
              id="message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder=" "
            />
            <label htmlFor="message">Mensaje</label>
          </div>
          <button type="submit">Enviar</button>
        </form>

        <div className="contact-info-c">
          <p>
            <strong>Correo:</strong>{' '}
            <a href="mailto:proyectos@ipsumiei.com">proyectos@ipsumiei.com</a>
          </p>
          <p>
            <strong>Sitio web:</strong>{' '}
            <a
              href="https://www.ipsumiei.com.co"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.ipsumiei.com.co
            </a>
          </p>

          <p className="direccion-item">
            <a
              href="https://maps.app.goo.gl/vmUnPuxDYSxvPAvs7"
              target="_blank"
              rel="noopener noreferrer"
              className="direccion-link"
            >
              <FaMapMarkerAlt className="icono-ubicacion" />
              Cr 8 N° 6-74, Barrio Ursua, Pamplona, Norte de Santander
            </a>
          </p>

          <p>
            <strong>Teléfono:</strong>{' '}
            <a href="tel:+573174988280">3174988280</a>,{' '}
            <a href="tel:+573024891161">3024891161</a>,{' '}
            <a href="tel:+573142376242">3142376242</a>
          </p>

          <div className="map-container">
            <div className="map-responsive">
              <a
                href="https://maps.app.goo.gl/vmUnPuxDYSxvPAvs7"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={Fachada}
                  alt="Ubicación IPSUM Ingeniería"
                  className="map-image"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
